// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"507cb582","233":"73d1badc","369":"57b29ed1","777":"d85915b3","936":"8bff68ae"}[chunkId] + ".js";
};